export default __webpack_public_path__ + "static/menu-gindakohighball-min3-2ff8e15ef4f154094cf6d310b8ee013b.jpg";